import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.downloads', {
        url: '/downloads',
        component: 'downloads',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/downloads/downloads.state.js